module.exports = __webpack_public_path__ + "static/media/frontOff.0032ce09.svg";